import { NavigationButton } from "@vega-core/components/Buttons/NavigationButton";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { type MenuGroupConfig } from "./types";

type Props = {
  group: MenuGroupConfig;
  background?: string;
};

export const MenuGroup = ({ group, background }: Props) => (
  <div className="border-border/secondary flex-col">
    {group.section ? (
      <div className="text-text/secondary heading-6 uppercase p-4 block">
        {group.section}
      </div>
    ) : null}
    <div
      className={cnTwMerge(
        "body-base-medium sm:rounded-lg border-1 border-border/primary",
        isTruthy(background) ? `bg-${background}` : "bg-background/primary",
      )}
      data-testid="menu-group-container"
    >
      {group.items.map((item) => (
        <div
          className={cnTwMerge("px-2 py-1", {
            "border-b border-border/primary": isTruthy(item.divided),
          })}
          data-testid={`menu-group-item-${item.label}`}
          key={`${item.label}-${item.route}`}
          onClick={item.onClick}
        >
          {isTruthy(item.component) ? (
            item.component
          ) : (
            <NavigationButton
              className="xs:justify-start md:justify-start"
              disabled={item.disabled}
              icon={item.icon}
              label={item.label}
              route={item.route ?? "#"}
            />
          )}
        </div>
      ))}
    </div>
  </div>
);
